export var EnrolledType;
(function (EnrolledType) {
    EnrolledType["NO"] = "no";
    EnrolledType["YES"] = "yes";
})(EnrolledType || (EnrolledType = {}));
